<template>
    <md-toolbar id="toolbar" md-elevation="0" class="md-white md-absolute" :class="extraNavClasses" :color-on-scroll="colorOnScroll">
        <div class="md-toolbar-row md-collapse-lateral">
            <div class="md-toolbar-section-start">
                <a href="#/"><img src="../assets/img/logos/alba1.png"/></a>
            </div>
            <div class="md-toolbar-section-end">
                <md-button class="md-just-icon md-simple md-toolbar-toggle" :class="{ toggled: toggledClass }" @click="toggleNavbarMobile()">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </md-button>

                <div class="md-collapse">
                    <div class="md-collapse-wrapper">
                        <mobile-menu nav-mobile-section-start="false">
                            <!-- Here you can add your items from the section-start of your toolbar -->
                        </mobile-menu>
                        <md-list>
                            <md-list-item href="javascript:void(0)" @click="scrollToElement1()" v-if="showDownload">
                                <h3 class="title">Bemyvega</h3>
                            </md-list-item>

                            <md-list-item href="javascript:void(0)" @click="scrollToElement()" v-if="showDownload">
                                <h3 class="title">Noticias</h3>
                            </md-list-item>

                            <li class="md-list-item">
                                <a href="javascript:void(0)" class="md-list-item-router md-list-item-container md-button-clean dropdown">
                                    <div class="md-list-item-content">
                                        <drop-down direction="down">
                                            <md-button slot="title" class="md-button md-button-link md-white md-simple dropdown-toggle" data-toggle="dropdown">
                                                <i class="material-icons">cloud_download</i>
                                                <h3 class="title">Recursos</h3>
                                            </md-button>
                                            <ul class="dropdown-menu dropdown-with-icons">
                                                <li>
                                                    <a href="#/landing">
                                                        <i class="material-icons">account_circle</i>
                                                        <h4 class="title">Chat</h4>
                                                    </a>
                                                </li>
                                                <!-- <li>
                                                    <a href="#/login">
                                                        <i class="material-icons">fingerprint</i>
                                                        <p>Archivos</p>
                                                    </a>
                                                </li> -->
                                                <li>
                                                    <a href="#/profile">
                                                        <i class="material-icons">view_day</i>
                                                        <h4 class="title">Archivos</h4>
                                                    </a>
                                                </li>
                                            </ul>
                                        </drop-down>
                                    </div>
                                </a>
                            </li>

                            <md-list-item style="margin-top:2rem;" href="https://twitter.com/ALBA_albinismo" target="_blank">
                                <i class="fab fa-twitter fa-5x"></i>
                                <p class="hidden-lg">Twitter</p>
                                <md-tooltip style="z-index:1050" md-direction="bottom">Siguenos en Twitter</md-tooltip>
                            </md-list-item>
                            <md-list-item style="margin-top:2rem;" href="https://es-es.facebook.com/AsociacionAlba/" target="_blank">
                                <i class="fab fa-facebook-square"></i>
                                <p class="hidden-lg">Facebook</p>
                                <md-tooltip style="z-index:1050" md-direction="bottom">Siguenos en Facebook</md-tooltip>
                            </md-list-item>
                            <md-list-item style="margin-top:2rem;" href="https://www.instagram.com/albinismoalba/" target="_blank">
                                <i class="fab fa-instagram"></i>
                                <p class="hidden-lg">Instagram</p>
                                <md-tooltip style="z-index:1050" md-direction="bottom">Siguenos en Instagram</md-tooltip>
                            </md-list-item>
                        </md-list>
                    </div>
                </div>
            </div>
        </div>
    </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
            resizeTimeout = null;
            actualResizeHandler();

            // The actualResizeHandler will execute at a rate of 15fps
        }, 66);
    }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
    components: {
        MobileMenu
    },
    props: {
        type: {
            type: String,
            default: "white",
            validator(value) {
                return ["white", "default", "primary", "danger", "success", "warning", "info"].includes(value);
            }
        },
        colorOnScroll: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            extraNavClasses: "",
            toggledClass: false
        };
    },
    computed: {
        showDownload() {
            const excludedRoutes = ["login", "landing", "profile"];
            return excludedRoutes.every((r) => r !== this.$route.name);
        }
    },
    methods: {
        bodyClick() {
            let bodyClick = document.getElementById("bodyClick");

            if (bodyClick === null) {
                let body = document.querySelector("body");
                let elem = document.createElement("div");
                elem.setAttribute("id", "bodyClick");
                body.appendChild(elem);

                let bodyClick = document.getElementById("bodyClick");
                bodyClick.addEventListener("click", this.toggleNavbarMobile);
            } else {
                bodyClick.remove();
            }
        },
        toggleNavbarMobile() {
            this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
            this.toggledClass = !this.toggledClass;
            this.bodyClick();
        },
        handleScroll() {
            let scrollValue = document.body.scrollTop || document.documentElement.scrollTop;
            let navbarColor = document.getElementById("toolbar");
            this.currentScrollValue = scrollValue;
            if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
                // this.extraNavClasses = `md-${this.type}`;
                // navbarColor.classList.remove("md-transparent");
            } else {
                if (this.extraNavClasses) {
                    this.extraNavClasses = "";
                    // navbarColor.classList.add("md-transparent");
                }
            }
        },
        scrollListener() {
            resizeThrottler(this.handleScroll);
        },
        scrollToElement() {
            let element_id = document.getElementById("downloadSection");
            if (element_id) {
                element_id.scrollIntoView({ block: "end", behavior: "smooth" });
            }
        },
        scrollToElement1() {
            let element_id = document.getElementById("downloadSection1");
            if (element_id) {
                element_id.scrollIntoView({ block: "end", behavior: "smooth" });
            }
        }
    },
    mounted() {
        document.addEventListener("scroll", this.scrollListener);
    },
    beforeDestroy() {
        document.removeEventListener("scroll", this.scrollListener);
    }
};
</script>
